
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_61574_22725)"}},[_c('path',{attrs:{"d":"M14.25 8a6.25 6.25 0 10-12.5 0 6.25 6.25 0 0012.5 0zm-7 4.081v-.412H6.247a.75.75 0 010-1.5h1.67a.758.758 0 01.166 0h.79a.708.708 0 00.138-1.402l-.139-.014h-1.75a2.21 2.21 0 010-4.417h.128v-.422a.75.75 0 011.5 0v.422h.997l.077.004a.75.75 0 010 1.492l-.077.004H7.122a.709.709 0 100 1.417h1.75l.219.01a2.208 2.208 0 01-.219 4.406H8.75v.412a.75.75 0 01-1.5 0zM15.75 8A7.75 7.75 0 11.25 8a7.75 7.75 0 0115.5 0z","fill":"#4A4A4A"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_61574_22725"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    